import * as React from 'react';
import { Modal, Row, Button, Form } from 'react-bootstrap';
import { FormDoc } from '../doc/FormDoc';
import { IValue } from '../state/State';

export interface DocFromJSONProps
{
  doc: FormDoc;
  visible: IValue<boolean>;
}

export class DocFromJSON extends React.Component<DocFromJSONProps>
{
  private inputControl: HTMLInputElement | null = null;

  public render()
  {
    return (
      <>
        <Button
          variant="outline-warning"
          onClick={() => this.props.visible.setNextState(true)}
        >
          DocFromJSON
        </Button>
        <Modal
          show={this.props.visible.state}
          // tslint:disable-next-line:no-empty
          onHide={() => { }}
        >
          <Modal.Header>Wpisz dokument w postaci JSON</Modal.Header>
          <Modal.Body>
            <Row>
              <Form.Control
                as="textarea"
                rows={10}
                ref={(input: any) => { this.inputControl = input; }}
              />
            </Row>
          </Modal.Body>
          <Modal.Footer style={{ textAlign: 'left' }}>
            <Button id="close" onClick={() => this.props.visible.setNextState(false)} >
              Anuluj
          </Button>
            <Button id="close" onClick={() => this.wczytaj()} >
              Wczytaj
          </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  private wczytaj(): void
  {
    if (this.inputControl)
    {
      const jsonText = this.inputControl.value;
      const json = JSON.parse(jsonText);

      this.props.doc.fromJSON({ doc: json }, []);
    }

    this.props.visible.setNextState(false);
  }
}
